export default __webpack_public_path__ + "static/media/logo_taboola.55f5867a.svg";